(() => {
  'use strict';

  const root = document.querySelector('[data-innungsportal-v3]');
  const directory = root?.querySelector('[data-zb-directory]');
  const results = directory?.querySelector('[data-zb-dir-results]');
  if (!directory || !results) return;

  const previewThemeId = new URL(location.href).searchParams.get('preview_theme_id');

  const norm = value => String(value || '')
    .toLocaleLowerCase('de')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ß/g, 'ss');

  const slug = value => norm(value)
    .replace(/&/g, ' und ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const profileHref = title => {
    const url = new URL(`/pages/${title === 'Spitzenverband für Orthopädie-Schuhtechnik e. V.' ? 'spitzenverband-orthopadieschuhtechnik-spiost' : slug(title)}`, location.origin);
    if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
    return url.pathname + url.search;
  };

  const enhance = () => {
    results.querySelectorAll('.zb-directory-card').forEach(card => {
      if (card.querySelector('.iv3-profile-link')) return;

      const title = card.querySelector('h3')?.textContent.trim();
      const links = card.querySelector('.zb-directory-card__links');
      if (!title || !links) return;

      const link = document.createElement('a');
      link.className = 'iv3-profile-link';
      link.href = profileHref(title);
      link.textContent = 'Profil öffnen →';
      link.setAttribute('aria-label', `Profil von ${title} öffnen`);
      links.prepend(link);
    });
  };

  let frame = 0;
  const scheduleEnhance = () => {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      frame = 0;
      enhance();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleEnhance, { once: true });
  } else {
    scheduleEnhance();
  }

  directory.querySelector('[data-zb-dir-search]')?.addEventListener('input', scheduleEnhance);
  directory.querySelector('[data-zb-dir-type]')?.addEventListener('change', scheduleEnhance);
  directory.querySelector('[data-zb-dir-state]')?.addEventListener('change', scheduleEnhance);
  directory.querySelector('[data-zb-dir-reset]')?.addEventListener('click', scheduleEnhance);
})();
